import styles from './lib/CheckBox.css?inline';
import { customElement } from 'solid-element';
import { CheckBox } from './lib/CheckBox';
import { mandatoryStyles } from '@formbird/solid-shared';

const CheckBoxWithStyles = (props: any) => {
  return (
    <>
      <style>{styles + mandatoryStyles}</style>
      <CheckBox {...props} />
    </>
  );
};

// Register the custom element
customElement('solid-check-box', {
    document: undefined as any,
    template: undefined as any,
    componentDefinition: undefined as any,
    fieldValue: '',
    fieldName: '',
    previousFieldValue: '',
    key: 0,
    formParameters: undefined as any,
}, CheckBoxWithStyles);

// Export the component for testing
export { CheckBox };
